<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "StrukturPemegangSaham",

  metaInfo: { title: "Struktur Pemegang Saham" },

  extends: View,

  mixins: [
    LoadSections([
      "hero-alt",
      // 'commissioner',
      // 'com-syariah',
      // 'boards',
      // "company-secretariat",
      // "audit-committe",
      // "audit-internal",
      "shareholder-structure",
      "info"
    ])
  ],

  props: {
    id: {
      type: String,
      default: "about"
    }
  }
};
</script>
